import React from 'react';

interface Event {
  id: number;
  name: string;
}

interface EventFilterProps {
  events: Event[];
  selectedFilter: 'all' | number;
  onFilterChange: (filter: 'all' | number) => void;
}

const EventFilter: React.FC<EventFilterProps> = ({
  events,
  selectedFilter,
  onFilterChange,
}) => {
  return (
    <section className="filter-section">
      <div className="filter-tabs">
        <button
          className={`filter-tab ${selectedFilter === 'all' ? 'active' : ''}`}
          onClick={() => onFilterChange('all')}
        >
          Tous
        </button>
        {events.map((event) => (
          <button
            key={event.id}
            className={`filter-tab ${selectedFilter === event.id ? 'active' : ''}`}
            onClick={() => onFilterChange(event.id)}
          >
            {event.name}
          </button>
        ))}
      </div>
    </section>
  );
};

export default EventFilter;
